import { render } from "./PackagesSection.vue?vue&type=template&id=75e93ce8&scoped=true"
import script from "./PackagesSection.vue?vue&type=script&lang=js"
export * from "./PackagesSection.vue?vue&type=script&lang=js"

import "./PackagesSection.vue?vue&type=style&index=0&id=75e93ce8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e93ce8"]])

export default __exports__